fragment DigestSubscriptionFragment on DigestSubscription {
    id
    isActive
    frequency
    digestType
}
